// Breakpoint at which the Volto layout collapses to a single column.
// Adjust this value if your theme uses a different mobile breakpoint.
const MOBILE_BREAKPOINT = '768px';

/**
 * Returns a responsive `sizes` string for the image block.
 *
 * On viewports narrower than MOBILE_BREAKPOINT the layout always collapses to
 * full width, so we always tell the browser `100vw` for mobile first, then
 * fall through to the desktop hint that matches the chosen align + size
 * combination.  Without the mobile condition the browser would fetch an
 * undersized source (e.g. the "preview" scale) and display it pixelated at
 * full width on a phone.
 */
export function getImageBlockSizes(data) {
  // Full-bleed: always 100vw at every viewport.
  if (data.align === 'full') return '100vw';

  if (data.align === 'center') {
    if (data.size === 'l')
      return `(max-width: ${MOBILE_BREAKPOINT}) 100vw, 100vw`;
    if (data.size === 'm')
      return `(max-width: ${MOBILE_BREAKPOINT}) 100vw, 50vw`;
    if (data.size === 's')
      return `(max-width: ${MOBILE_BREAKPOINT}) 100vw, 25vw`;
  }

  if (data.align === 'left' || data.align === 'right') {
    // Floated images also stack above content on mobile → 100vw.
    if (data.size === 'l')
      return `(max-width: ${MOBILE_BREAKPOINT}) 100vw, 50vw`;
    if (data.size === 'm')
      return `(max-width: ${MOBILE_BREAKPOINT}) 100vw, 25vw`;
    if (data.size === 's')
      return `(max-width: ${MOBILE_BREAKPOINT}) 100vw, 15vw`;
  }

  return undefined;
}
